export var colorShade = function (color, amount) {
    var _a;
    color = color.replace(/^#/, "");
    if (color.length === 3)
        color = color[0] + color[0] + color[1] + color[1] + color[2] + color[2];
    var _b = color.match(/.{2}/g), r = _b[0], g = _b[1], b = _b[2];
    _a = [
        parseInt(r, 16) + amount,
        parseInt(g, 16) + amount,
        parseInt(b, 16) + amount,
    ], r = _a[0], g = _a[1], b = _a[2];
    r = Math.max(Math.min(255, r), 0).toString(16);
    g = Math.max(Math.min(255, g), 0).toString(16);
    b = Math.max(Math.min(255, b), 0).toString(16);
    var rr = (r.length < 2 ? "0" : "") + r;
    var gg = (g.length < 2 ? "0" : "") + g;
    var bb = (b.length < 2 ? "0" : "") + b;
    return "#".concat(rr).concat(gg).concat(bb);
};
export var hexToRGB = function (color) {
    return [1, 3, 5].map(function (i) { return parseInt(color.substring(i, i + 2), 16); });
};
export var tone = function (color, amount) {
    return "#".concat(hexToRGB(color)
        .map(function (c) {
        return clamp(c + amount, 0, 255)
            .toString(16)
            .padStart(2, "0");
    })
        .join(""));
};
var clamp = function (number, lower, upper) {
    if (number < lower) {
        return lower;
    }
    if (number > upper) {
        return upper;
    }
    return number;
};
